import PropTypes from 'prop-types'

export const globalConfigPropTypes = {
  isGlobalConfig: PropTypes.bool.isRequired,
  onChangeGlobalConfig: PropTypes.func.isRequired
}
